<template>  
  	<div>
		<questions
			:areas="areas"
			:questions="questions"
			@on-active="$emit('on-active', $event)"
			@show-questions="$emit('show-questions', $event)"
			@quantity-selected="$emit('quantity-selected', $event)"
		/>
	</div>
</template>

<script>
import questions from '@/components/questions';

export default {
	name: 'step-three',
	components: {
		questions,
	},
	props: {
		areas: {
			default: () => [],
			type: Array,
		},
		questions: {
			default: () => [],
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
	.btn-section {
		background-color: map-get($colors, white);
		border-top: 1px solid map-get($colors, gray-slider);
		bottom: 0;
		height: 92px;
		left: 70px;
		position: fixed;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/surveys/step-three.vue